import {createReducer} from '@reduxjs/toolkit';

import {
  setCollectionVisibility,
  toggleCollectionVisibility,
} from '@app/actions/collections';
import {getHashFromId} from '@app/util/granero';

export const initialState = {
  visibleIds: [],
};

export default createReducer(initialState, builder => {
  builder.addCase(
    toggleCollectionVisibility,
    (state, {payload: collection}) => {
      const collectionHashId = getHashFromId(collection.id);

      if (state.visibleIds.includes(collectionHashId)) {
        state.visibleIds = state.visibleIds.filter(
          id => id !== collectionHashId
        );
      } else {
        state.visibleIds = [...state.visibleIds, collectionHashId];
      }
    }
  );

  builder.addCase(
    setCollectionVisibility,
    (state, {payload: {collection, visible}}) => {
      const collectionHashId = getHashFromId(collection.id);
      if (!visible) {
        state.visibleIds = state.visibleIds.filter(
          id => id !== collectionHashId
        );
      } else {
        state.visibleIds = Array.from(
          new Set([...state.visibleIds, collectionHashId])
        );
      }
    }
  );
});
